interface AboutCard {
  title: string;
  description: string;
}

interface CapabilityCard {
  title: string;
  description: string;
}

interface AdvantageCard {
  title: string;
  description: string;
}

export interface ProcessCard {
  title: string;
  description: string;
}

export interface OurWorkProject {
  logo: string;
  title: string;
  url: string;
  description: string;
  caseStudyImage: string;
  summaryTags: string[];
  capabilities: string[];
  summaryDescription: string;
}

export const ourWorkProjects: OurWorkProject[] = [
  {
    title: "Thrifty Traveler",
    description:
      "Thrifty Traveler is a travel discount service and consulting agency that helps customers find the best flight and hotel deals and provide guidance on all things travel, travel cards and points, and everything in between.",
    logo: "/assets/our-work/thrifty-traveler-logo.png",
    caseStudyImage: "/assets/our-work/thrifty-traveler-case-study-image.png",
    summaryTags: ["Proprietary LLM", "Application", "Native Apps"],
    capabilities: [
      "Brand Design",
      "UX DESIGN",
      "Project management",
      "Cross-Team Collaboration",
    ],
    url: "https://thriftytraveler.com/news/credit-card/thrifty-traveler-cardgenius/",
    summaryDescription:
      "Custom Al solutions that deliver measurable business outcomes.",
  },

  {
    title: "Dock Pro Apple Vision Pro App + Website",
    description:
      "This essential Apple Vision Pro companion app provides quick access links within your immersive world, with real-time displays of time, date, and battery percentage always present. Your things, at a glance.",
    logo: "/assets/our-work/dock-pro-logo.png",
    caseStudyImage: "/assets/our-work/our-work-dock-pro-case-study-image.jpg",
    summaryTags: ["Apple Vision Pro", "Website", "Native Apps"],
    capabilities: [
      "Brand Design",
      "UX DESIGN",
      "Project management",
      "App Deployment",
      "Immersive Experience",
      "XR",
    ],
    url: "https://www.dockpro.app",
    summaryDescription:
      "An innovative floating dock for all your favorite things.",
  },
];

/* Thrifty Traveler 

/assets/our-work/thrifty-traveler-case-study-image.png
                
                /assets/our-work/thrifty-traveler-logo.png
                    
                    Thrifty Traveler is a travel discount service and consulting
                    agency that helps customers find the best flight and hotel
                    deals and provide guidance on all things travel, travel
                    cards and points, and everything in between.
                    
                    Proprietary LLM
                      Application
                      Native Apps
                      
                      Custom Al solutions that deliver measurable business
                    outcomes.
                    
                    Brand Design
                      UX/UI DESIGN
                      Project management
                      Cross-Team Collaboration */

export const aboutCards: AboutCard[] = [
  {
    title: "From Pencil to Polish...",
    description:
      "We are your product development and software implementation partners. With over 25 years of collective experience, we specialize in transforming complex technical challenges into elegant, growth-driving solutions for small businesses ready to scale.",
  },
  {
    title: "Design + Full Stack Development",
    description:
      "We unite exceptional design with advanced engineering to deliver enterprise-grade digital products. Our unified approach ensures seamless execution from concept to deployment, bringing sophisticated capabilities within reach of growing businesses.",
  },
  {
    title: "Our Expertise",
    description:
      "End-to-end product development<br /><br />Expert UI/UX design and full-stack implementation<br /><br />Custom AI integration and optimization",
  },
];

export const capabilityCards: CapabilityCard[] = [
  {
    title: "Technical Strategy",
    description:
      "Strategic technology decisions backed by 25+ years of product expertise.",
  },
  {
    title: "Gen AI Integration",
    description:
      "Custom AI solutions that deliver measurable business outcomes.",
  },
  {
    title: "Full-Stack Engineering",
    description:
      "Enterprise-grade full-stack development with performance optimization.",
  },
  {
    title: "UX and Product Design",
    description: "Expert UI/UX design that drives user engagement and impact.",
  },
];

export const advantageCards: AdvantageCard[] = [
  {
    title: "Enterprise DNA",
    description:
      "25+ years of collective product development expertise, bringing Fortune 500 quality to growing businesses.",
  },
  {
    title: "Unified Design & Development",
    description:
      "Seamless integration of exceptional design and expert engineering—no handoff gaps, just flawless execution.",
  },
  {
    title: "Full-Spectrum Innovation",
    description:
      "From pixel-perfect design to advanced Gen AI integration, we deliver complete solutions that drive business growth.",
  },
  {
    title: "Results-Focused Approach",
    description:
      "Enterprise-quality outcomes with small business agility, ensuring your technology investments deliver measurable value.",
  },
];

export const processCards: ProcessCard[] = [
  {
    title: "Partnership Approach",
    description:
      "We view every project as a true partnership. Your success is our success—from initial planning through long-term support.",
  },
  {
    title: "Discovery and Planning",
    description:
      "We begin with deep discovery, understanding your requirements, business goals, and stakeholders. This foundation ensures every decision drives value.",
  },
  {
    title: "Development & Implementation",
    description:
      "We implement solutions using proven product management and development methodologies, ensuring quick iterations and continuous feedback. We focus on delivering value at every step while maintaining high-quality standards.",
  },
  {
    title: "Quality & Refinement",
    description:
      "Through rigorous testing and refinement, we ensure your solution meets the highest performance, security, and user experience standards. We fine-tune every detail for optimal results.",
  },
  {
    title: "Launch & Beyond",
    description:
      "We ensure a smooth launch and provide ongoing support and optimization. Our partnership continues as we help you evolve and scale your solution to meet future needs.",
  },
];
